import { materialTypeOptionLabels } from '@domainConstants'
import convert from 'convert'
import { format } from 'mathjs'
import { GridColDef } from '@mui/x-data-grid-premium'
import { remapMaterialIdentifier } from 'src/components/pages/Editor/components/SingleElementCSForm/components/FormFields'

export const baseColumns: GridColDef[] = [
  {
    field: 'wall_label',
    headerName: 'Wand',
    type: 'string',
    description: 'Label der Wand',
    headerAlign: 'center',
    editable: false,
    width: 140,
  },
  {
    field: 'assembly_short_name',
    headerName: 'Aufbau',
    type: 'string',
    description: 'Kürzel des Aufbaus',
    headerAlign: 'center',
    editable: false,
    width: 140,
  },
  {
    field: 'wall_type',
    headerName: 'Typ',
    type: 'string',
    description: 'Typ der Wand',
    headerAlign: 'center',
    editable: false,
    width: 140,
  },
  {
    field: 'design_normal_force_fire',
    headerName: 'Fc,0,d,fi',
    type: 'number',
    description: 'Design-Druckkraft bei Brand',
    headerAlign: 'center',
    editable: false,
    valueFormatter: value =>
      `${format(convert(value, 'N').to('kN'), { notation: 'fixed', precision: 2 })} kN`,
  },
  {
    field: 'material_type',
    headerName: 'Materialtyp',
    type: 'string',
    description: 'Materialtyp',
    headerAlign: 'center',
    editable: false,
    valueFormatter: value => materialTypeOptionLabels[value],
  },
  {
    field: 'material_identifier',
    headerName: 'Material',
    type: 'string',
    description: 'Material Identifier',
    headerAlign: 'center',
    editable: false,
    valueFormatter: value => remapMaterialIdentifier(value),
  },

  {
    field: 'height',
    headerName: 'h',
    type: 'number',
    description: 'Höhe der Rippe',
    headerAlign: 'center',
    editable: false,
    valueFormatter: value => `${convert(value, 'm').to('mm')} mm`,
  },
  {
    field: 'width',
    headerName: 'b',
    type: 'number',
    description: 'Breite der Rippe',
    headerAlign: 'center',
    editable: false,
    valueFormatter: value => `${convert(value, 'm').to('mm')} mm`,
  },
  {
    field: 'length',
    headerName: 'l',
    type: 'number',
    description: 'Länge der Rippe',
    headerAlign: 'center',
    editable: false,
    valueFormatter: value => `${format(value, { notation: 'fixed', precision: 1 })} m`,
  },
  {
    field: 't_req',
    headerName: 't_req',
    type: 'number',
    description: 'Branddauer',
    headerAlign: 'center',
    editable: false,
    valueFormatter: value => `${convert(value, 's').to('min')} min`,
    flex: 1,
  },
]

export const timberRipColumns: GridColDef[] = [
  {
    field: 'exported',
    headerName: 'Exportiert',
    type: 'boolean',
    description: 'Rippe wird exportiert',
    headerAlign: 'center',
    editable: false,
    width: 120,
  },
  {
    field: 'representative',
    headerName: 'Gruppe',
    type: 'boolean',
    description: 'Repräsentiert eine Gruppe',
    headerAlign: 'center',
    editable: false,
    width: 120,
  },
  {
    field: 'rip_label',
    headerName: 'Bauteil',
    type: 'string',
    description: 'Label der Rippe',
    headerAlign: 'center',
    editable: false,
    minWidth: 140,
  },
  ...baseColumns,
]

export const unexportedFields = ['exported', 'representative']
